// PostHog init — side-effect import dans AppProviders. No-op si VITE_POSTHOG_KEY
// absent. Source : PRD 18 analytics.
import posthog from "posthog-js";
import { getEnv } from "./env";

let initialized = false;

export function initPostHog(): void {
  if (initialized) return;
  const env = getEnv();
  if (!env.VITE_POSTHOG_KEY) return;
  posthog.init(env.VITE_POSTHOG_KEY, {
    api_host: env.VITE_POSTHOG_HOST ?? "https://eu.posthog.com",
    capture_pageview: true,
    capture_pageleave: true,
    person_profiles: "identified_only",
    autocapture: false, // privacy-first : on capture explicitly
  });
  initialized = true;
}

export { posthog };
